import { render, staticRenderFns } from "./UnsuccessDeliveryProductCost.vue?vue&type=template&id=59dcb3bc&lang=pug&"
import script from "./UnsuccessDeliveryProductCost.vue?vue&type=script&lang=ts&"
export * from "./UnsuccessDeliveryProductCost.vue?vue&type=script&lang=ts&"
import style0 from "./UnsuccessDeliveryProductCost.vue?vue&type=style&index=0&id=59dcb3bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports